/**
 * GoNOW API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2020-12-7
 * Contact: info@zero-spec.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
* The SupplyResponse model module.
* @module model/SupplyResponse
* @version 2020-12-7
*/
export default class SupplyResponse {
    /**
    * Constructs a new <code>SupplyResponse</code>.
    * 補給
    * @alias module:model/SupplyResponse
    * @class
    * @param customerId {Number} 顧客ID
    * @param timestamp {Number} 補給時刻
    * @param amount {Number} 補給量 (L)
    * @param updatedAt {Number} 最終更新時刻(epoch秒)
    */

    constructor(customerId, timestamp, amount, updatedAt) {
        
        
        this['customerId'] = customerId;
        this['timestamp'] = timestamp;
        this['amount'] = amount;
        this['updatedAt'] = updatedAt;
        
    }

    /**
    * Constructs a <code>SupplyResponse</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/SupplyResponse} obj Optional instance to populate.
    * @return {module:model/SupplyResponse} The populated <code>SupplyResponse</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new SupplyResponse();
                        
            
            if (data.hasOwnProperty('customerId')) {
                obj['customerId'] = ApiClient.convertToType(data['customerId'], 'Number');
            }
            if (data.hasOwnProperty('timestamp')) {
                obj['timestamp'] = ApiClient.convertToType(data['timestamp'], 'Number');
            }
            if (data.hasOwnProperty('amount')) {
                obj['amount'] = ApiClient.convertToType(data['amount'], 'Number');
            }
            if (data.hasOwnProperty('updatedAt')) {
                obj['updatedAt'] = ApiClient.convertToType(data['updatedAt'], 'Number');
            }
        }
        return obj;
    }

    /**
    * 顧客ID
    * @member {Number} customerId
    */
    'customerId' = undefined;
    /**
    * 補給時刻
    * @member {Number} timestamp
    */
    'timestamp' = undefined;
    /**
    * 補給量 (L)
    * @member {Number} amount
    */
    'amount' = undefined;
    /**
    * 最終更新時刻(epoch秒)
    * @member {Number} updatedAt
    */
    'updatedAt' = undefined;




}
